export default {
    'page': import('@/components/integrations/protokol/storefront/Page')
}